import { createContext } from 'react';

export const ContigoContext =  createContext ();